import { Box } from "@mui/material";
import { Components } from "@mui/material/styles";

const Icon = () => (
    <Box
        className="radio-button-icon"
        sx={{
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <Box
            className="radio-button-icon__inner"
            sx={{
                borderRadius: "50%",
            }}
        />
    </Box>
);

const CheckedIcon = () => (
    <Box
        className="radio-button-icon-checked"
        sx={{
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <Box
            className="radio-button-icon-checked__inner"
            sx={{
                borderRadius: "50%",
            }}
        />
    </Box>
);

export const MuiRadio: Components["MuiRadio"] = {
    defaultProps: {
        disableRipple: true,
        icon: <Icon />,
        checkedIcon: <CheckedIcon />,
    },
    styleOverrides: {
        root: {
            color: "var(--mui-palette-gray-800)",
            padding: 0,

            "&.Mui-focusVisible .radio-button-icon, &.Mui-focusVisible .radio-button-icon-checked": {
                boxShadow: "0 0 0 2px var(--mui-palette-gray-800)",
            },

            "&.Mui-focusVisible .radio-button-icon-checked": {
                borderColor: "var(--mui-palette-gray-400)",
            },

            "&.Mui-disabled .radio-button-icon, &.Mui-disabled .radio-button-icon-checked": {
                backgroundColor: "var(--mui-palette-gray-100)",
                borderColor: "var(--mui-palette-gray-100)",
            },

            "&.Mui-disabled .radio-button-icon-checked__inner": {
                backgroundColor: "var(--mui-palette-gray-200)",
            },

            "& .radio-button-icon": {
                width: "24px",
                height: "24px",
                backgroundColor: "#fff",
                border: "1px solid var(--mui-palette-gray-400)",
                transition: "box-shadow 0.2s",
            },

            "& .radio-button-icon-checked": {
                width: "24px",
                height: "24px",
                backgroundColor: "var(--mui-palette-gray-800)",
                border: "1px solid var(--mui-palette-gray-800)",
                transition: "box-shadow 0.2s",
            },

            "& .radio-button-icon-checked__inner": {
                width: "10px",
                height: "10px",
                backgroundColor: "#fff",
            },

            "&.MuiRadio-sizeSmall .radio-button-icon": {
                width: "16px",
                height: "16px",
            },

            "&.MuiRadio-sizeSmall .radio-button-icon-checked": {
                width: "16px",
                height: "16px",
            },

            "&.MuiRadio-sizeSmall .radio-button-icon-checked__inner": {
                width: "6px",
                height: "6px",
            },
        },
    },
};
